import { createComponent as cc } from 'react-fela';

const GridWrapper = cc(() => ({
  margin: '90px 20px 20px 20px',
}));

export default GridWrapper;



// WEBPACK FOOTER //
// ./src/components/wrappers/GridWrapper.js